import VideoItem from '../VideoItem';
import styles from './index.module.css';

interface VideosListProps {
  dataVideos: any;
  isPending?: boolean;
  courtLabel?: string;
  dateLabel?: string;
  variant?: 'default' | 'ft';
}

function VideosList({ dataVideos, courtLabel, dateLabel, variant = 'default' }: VideosListProps) {
  const videos = (dataVideos ?? []).filter((v: any) => v?.videoUrl);

  return (
    <div className={`${styles.video_container} ${variant === 'ft' ? styles.ft : ''}`}>
      {videos.length > 0 && (
        <div className={styles.video_head}>
          <h2 className={styles.video_title}>Seus replays</h2>
          <span className={styles.video_count}>
            {videos.length} {videos.length === 1 ? 'clipe disponível' : 'clipes disponíveis'}
          </span>
        </div>
      )}

      <div className={styles.video_grid}>
        {videos.map((video: any, index: number) => (
          <VideoItem
            key={video.videoUrl + index}
            video={video}
            courtLabel={courtLabel}
            dateLabel={dateLabel}
            variant={variant}
          />
        ))}
      </div>
    </div>
  );
}

export default VideosList;
